import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { TrainingEvent, TrainingEventsResponse } from '@app/interfaces/public/training-event.interfaces';

@Injectable({ providedIn: 'root' })
export class TrainingEventService {
  private readonly publicTrainingEventsUrl = `${environment.apiUrl}/public/training-events`;
  private readonly adminTrainingEventsUrl = `${environment.apiUrl}/admin/training-events`;

  constructor(private http: HttpClient) {}

  /** Public — returns split { upcoming, past } lists */
  getTrainingEvents(): Observable<TrainingEventsResponse> {
    return this.http.get<TrainingEventsResponse>(this.publicTrainingEventsUrl);
  }

  /** Public — get a single training event by UUID */
  getTrainingEvent(id: string): Observable<TrainingEvent> {
    return this.http.get<TrainingEvent>(`${this.publicTrainingEventsUrl}/${id}`);
  }

  /** Admin — paginated list with optional filters */
  getAdminTrainingEvents(page: number = 1, params: Record<string, string> = {}): Observable<any> {
    const query = new URLSearchParams({ page: String(page), ...params }).toString();
    return this.http.get<any>(`${this.adminTrainingEventsUrl}?${query}`);
  }

  /** Admin — create a new training event */
  addTrainingEvent(formData: FormData): Observable<TrainingEvent> {
    return this.http.post<TrainingEvent>(this.adminTrainingEventsUrl, formData);
  }

  /** Admin — update an existing training event */
  updateTrainingEvent(id: string, formData: FormData): Observable<TrainingEvent> { formData.append('_method', 'PUT');
    return this.http.post<TrainingEvent>(`${this.adminTrainingEventsUrl}/${id}`, formData);
  }

  /** Admin — toggle upcoming/past status */
  toggleUpcoming(id: string): Observable<TrainingEvent> {
    return this.http.patch<TrainingEvent>(
      `${this.adminTrainingEventsUrl}/${id}/toggle-upcoming`,
      {},
    );
  }

  /** Admin — delete a training event */
  deleteTrainingEvent(id: string): Observable<any> {
    return this.http.delete(`${this.adminTrainingEventsUrl}/${id}`);
  }

  bulkDeleteTrainingEvents(ids: string[]): Observable<any> {
    return this.http.post(`${this.adminTrainingEventsUrl}/bulk-delete`, { ids });
  }

  updateOrder(items: Array<{ id: string; display_order: number }>): Observable<any> {
    return this.http.post(`${this.adminTrainingEventsUrl}/update-order`, { items });
  }
}
